const parseUrl = require('parseurl')
const xss = require('xss')
const juice = require('juice')
const xssFilter = new xss.FilterXSS({
  onIgnoreTagAttr(tag, name, value, isWhiteAttr) {
    if (~['style', 'class'].indexOf(name)) {
      return name + '="' + xss.escapeAttrValue(value) + '"'
    }
  },
  onIgnoreTag: function(tag, html, options) {
    if (tag === 'style') {
      return html
    }
    // 非白名单标签删除处理
    return ''
  }
})

module.exports = function() {
  return {
    $get:
            function() {
              /* --------------------html--------------------- */
              const html = {
                // 去掉所有的html标记
                delHtmlTag: function delHtmlTag(str) {
                  return str.replace(/<[^>]+>/g, '')
                },
                /**
                 * 把 textarea 里的内容转码为 HTML
                 * @param  {string} content
                 * @return {string}
                 */
                convertTextareaContent: function(content) {
                  return content ? content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')/* .replace(/ /ig, "&nbsp;") */.replace(/"/g, '&quot;').replace(/\n/ig, '&lt;br&gt;') : content
                },

                /**
                 * 替换textarea里的空格和换行
                 * @param  {string} content
                 * @return {string}
                 */
                convertTextareaEnter: function(content) {
                  return content ? content.replace(/ /ig, '&nbsp;').replace(/\n/ig, '<br/>') : content
                },

                /**
                 *  escape HTML
                 * @param content
                 * @returns {XML|string}
                 */
                encode: function(content) {
                  return !content ? '' : content.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
                },

                decode: function(content) {
                  return !content ? '' : content.replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').replace(/(&quot;|&#034;)/gi, '"').replace(/&#039;/gi, "'").replace(/&nbsp;/gi, ' ')
                },

                /**
                 * 检测数据类型
                 * @param obj
                 */
                typeOf: function(obj) {
                  const toString = Object.prototype.toString
                  const typeHash = {
                    'undefined': 'undefined',
                    'number': 'number',
                    'boolean': 'boolean',
                    'string': 'string',
                    '[object Function]': 'function',
                    '[object RegExp]': 'regexp',
                    '[object Array]': 'array',
                    '[object Date]': 'date',
                    '[object Error]': 'error'
                  }
                  let type = typeHash[typeof obj] || typeHash[toString.call(obj)] || (obj ? 'object' : 'null')

                  // 细化number的类型
                  if (type === 'number') {
                    const str = obj.toString()
                    if (str.indexOf('.') == -1) {
                      if (obj >= -2 * 1024 * 1024 * 1024 & obj < 2 * 1024 * 1024 * 1024) {
                        type = 'int'
                      } else if (isFinite(obj)) {
                        type = 'long'
                      }
                    }
                  }
                  return type
                },

                /**
                 * 去掉字符串两边的空格
                 * @param value
                 */
                trim: function(value) {
                  // native trim is way faster: http://jsperf.com/angular-trim-test
                  // but IE doesn't have it... :-(
                  // TODO: we should move this into IE/ES5 polyfill
                  if (!String.prototype.trim) {
                    return (html.typeOf(value) === 'string') ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value
                  }

                  return (html.typeOf(value) === 'string') ? value.trim() : value
                },

                /**
                     * 判断对象是否为空
                     * @param obj
                     */
                isEmptyObject: function(obj) {
                  let name
                  for (name in obj) {
                    return false
                  }
                  return true
                },

                getRealLength: function (str) {
                  /// <summary>获得字符串实际长度，中文2，英文1</summary>
                  /// <param name="str">要获得长度的字符串</param>
                  let realLength = 0
                  const len = str.length
                  let charCode = -1
                  for (let i = 0; i < len; i++) {
                    charCode = str.charCodeAt(i)
                    if (charCode >= 0 && charCode <= 128) realLength += 1
                    else realLength += 2
                  }
                  return realLength
                },

                stringToXml: function(sXMl) {
                  return (new DOMParser()).parseFromString(sXMl, 'application/xml')
                },

                parseUrlQuery: function (url) {
                  const query = {}
                  let param
                  if (~url.indexOf('?')) url = url.split('?')[1]
                  const params = url.split('&')
                  for (let i = 0; i < params.length; i++) {
                    param = params[i].split('=')
                    query[param[0]] = param[1]
                  }
                  return query
                },

                parseURL: function (url) {
                  // parser.href = "http://example.com:3000/pathname/?search=test#hash";

                  // parser.protocol; // => "http:"
                  // parser.host;     // => "example.com:3000"
                  // parser.hostname; // => "example.com"
                  // parser.port;     // => "3000"
                  // parser.pathname; // => "/pathname/"
                  // parser.hash;     // => "#hash"
                  // parser.search;   // => "?search=test"
                  const urlParseResult = parseUrl({
                    url: url
                  })
                  return urlParseResult
                },

                getBaseURL() {
                  const origin = `${location.protocol}//${location.hostname}${location.port ? `:${location.port}` : ''}`
                  return origin.startsWith('file:') ? '*' : origin
                },

                loadURL: function (url) {
                  let iFrame = document.createElement('iframe')
                  iFrame.setAttribute('src', url)
                  iFrame.setAttribute('style', 'display:none;')
                  iFrame.setAttribute('height', '0px')
                  iFrame.setAttribute('width', '0px')
                  iFrame.setAttribute('frameborder', '0')
                  document.body.appendChild(iFrame)
                  iFrame.parentNode.removeChild(iFrame)
                  iFrame = null
                },
                filterXSS: function(content) {
                  return xssFilter.process(content)
                },
                // 内容数据处理
                filterMailContent(mailContent, maxLimit) {
                  if (!mailContent) return mailContent

                  // 性能有点担忧，maxLimit存时只处理限制范围内的邮件
                  if (maxLimit && mailContent.length > maxLimit) return mailContent

                  // 转成行内样式（防止邮件样式污染全局样式）
                  mailContent = /<style[^>]*>[\s\S]*?<\/style>/i.test(mailContent) ? juice(mailContent, {preserveMediaQueries: false}) : mailContent
                  // 去除原来DOM上的类（防止全局样式污染邮件样式）
                  mailContent = mailContent.replace(/class\s*?=\s*?['"].+?['"]\s*?/g, '')

                  // 解决&nbsp;导致的单词内换行失效问题（目前编辑器只会引入&nbsp; 后面可以视情况补充）
                  mailContent = mailContent.replace(/(&nbsp;)+/g, function(matched, item, index) {
                    const blankLength = matched.length / item.length
                    const preWord = mailContent[index - 1]
                    const nextWord = mailContent[index + matched.length]

                    if (preWord === ' ' && nextWord === ' ') return matched
                    if (preWord === ' ') return matched.slice(0, -item.length) + ' '
                    if (nextWord === ' ') return ' ' + matched.slice(item.length)

                    // 前后都不为空
                    if (blankLength > 2) return ' ' + matched.slice(item.length, -item.length) + ' '
                    if (blankLength === 2) return ' ' + item
                    return ' '
                  })
                  return mailContent
                }
              }

              return html
            }
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/html.js